import { User } from './../../core/interfaces/user.model';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from 'src/app/core/auth/auth.service';
import { AccountService } from 'src/app/core/services/account.service';

@Component({
  selector: 'app-register-form',
  templateUrl: './register-form.component.html',
  styleUrls: ['./register-form.component.css'],
})
export class RegisterFormComponent implements OnInit {
  @Input() esModal: boolean = false;
  @Output() resultEvent = new EventEmitter<any>();
  @Output() goLogin = new EventEmitter<any>();

  registroForm: FormGroup;
  cargando = false;

  constructor(private auth: AuthService, private location: Location, private router: Router, private accountService: AccountService) {
    this.registroForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{8,9}$')]),
      documentId: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      zipcode: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{1,}$')]),
      state: new FormControl('', [Validators.required]),
      country: new FormControl('', [Validators.required]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
    });
  }

  ngOnInit(): void {
    if (!this.esModal) this.auth.estaAutenticado('/home');
  }

  onSubmit() {
    const polentaurl = this.accountService.polentaUrlExists() ? this.accountService.polentaUrl : '';
    if (this.registroForm.valid) {
      this.cargando = true;
      let usuario: User = {
        firstName: this.registroForm.get('firstName').value,
        lastName: this.registroForm.get('lastName').value,
        email: this.registroForm.get('email').value,
        documentId: this.registroForm.get('documentId').value,
        phoneNumber: this.registroForm.get('phoneNumber').value,
        address: this.registroForm.get('address').value,
        zipCode: parseInt(this.registroForm.get('zipcode').value),
        city: this.registroForm.get('city').value,
        country: this.registroForm.get('country').value,
        state: this.registroForm.get('state').value,
        polentaUrl: polentaurl,
      };

      this.auth.registro(usuario).then((resp) => {
        this.cargando = false;
        if (resp) {
          this.resultEvent.emit(resp);
        }
      });
    }
  }

  back() {
    this.location.back();
  }

  login() {
    if (!this.esModal) {
      this.router.navigateByUrl('/login');
    }

    this.goLogin.emit('/login');
  }
}
